import React from "react";
import { UtensilsCrossed, ShoppingBag } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { BocauxMenu } from "./BocauxMenu";
import Reveal from "./Reveal";

const T = {
  fr: {
    tag: "La Cuisine de Mon Père",
    title: "Les bocaux, cuisine maison en partenariat",
    text: "Des plats maison préparés en bocal avec des produits frais et locaux, à déguster tout simplement.",
    prices: "Entrée 7 € · Plat 13 € · Dessert 7 €",
    also: "Également disponible : nos galettes & crêpes bretonnes, sur réservation.",
    takeaway: "Dans les gîtes : formule à emporter uniquement, pas de repas servi sur place.",
    onsite: "Servis le soir, sur réservation, à la table partagée des chambres d'hôtes.",
  },
  en: {
    tag: "La Cuisine de Mon Père",
    title: "The jars, homemade cuisine in partnership",
    text: "Homemade dishes prepared in a jar with fresh, local produce, to simply enjoy.",
    prices: "Starter €7 · Main €13 · Dessert €7",
    also: "Also available: our Breton galettes & crêpes, by reservation.",
    takeaway: "In the cottages: take-away only, no meal served on site.",
    onsite: "Served in the evening, by reservation, at the guest-house shared table.",
  },
};

export const BocauxTeaser = ({ takeawayOnly = false, image, className = "" }) => {
  const { lang } = useI18n();
  const c = T[lang] || T.fr;
  return (
    <section className={`py-16 lg:py-24 ${className}`} data-testid="bocaux-teaser">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <Reveal className="lg:order-2">
            <img
              src={image || "/api/files/begaudiere/uploads/08b036a5-2b72-4d6c-8231-1405803ec50f.webp"}
              alt="La Cuisine de Mon Père · Les bocaux"
              loading="lazy"
              decoding="async"
              className="rounded-2xl w-full aspect-[4/3] object-cover"
            />
          </Reveal>
          <Reveal delay={120} className="lg:order-1">
            <span className="inline-flex items-center gap-2 rounded-full bg-brand-50 px-4 py-1.5 text-xs font-medium tracking-wide text-brand mb-4">
              <UtensilsCrossed size={15} strokeWidth={1.75} /> {c.tag}
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl text-ink-900 mb-4">{c.title}</h2>
            <p className="text-ink-600 font-body leading-relaxed mb-4">{c.text}</p>
            <p className="font-heading text-lg text-brand mb-3">{c.prices}</p>
            <p className="font-body text-sm text-ink-500 mb-5" data-testid="bocaux-galettes-note">{c.also}</p>
            {takeawayOnly ? (
              <div className="flex items-start gap-3 rounded-2xl bg-brand-50 p-5 mb-6" data-testid="bocaux-takeaway-note">
                <ShoppingBag size={22} strokeWidth={1.5} className="text-brand shrink-0 mt-0.5" />
                <p className="font-body text-sm text-ink-700 leading-relaxed">{c.takeaway}</p>
              </div>
            ) : (
              <p className="font-body text-sm text-ink-500 mb-6">{c.onsite}</p>
            )}
            <BocauxMenu />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default BocauxTeaser;
